import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';
import { Table } from 'primeng/table';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { CustoMaterialServico } from 'src/app/admihair/api/dto/custo-material-servico';
import { CustoMaterialServicoService } from 'src/app/admihair/service/custo-material-servico.service';
import { ItemServicoCustoMaterial } from 'src/app/admihair/api/dto/item-servico-custo-material';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';


@Component({
  selector: 'app-item-servico-editar',
  templateUrl: './item-servico-editar.component.html',
  styleUrls: ['./item-servico-editar.component.scss']
})
export class ItemServicoEditarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  itemServico?: ItemServico;
  codigoExistente: boolean = false;
  subgrupos: Subgrupo[] = [];
  subgrupoSelecionado?: Subgrupo;
  grupos: SelectItem[] = [];
  tributacaoChecked: boolean = false;
  codigoInicial: any;
  progressoRequisicao: boolean = false;

  listaAgenda: any[] = [
    {
      descricao: 'SIM',
      valor: 'SIM'
    },
    {
      descricao: 'NÃO',
      valor: 'NAO'
    },
    {
      descricao: 'EXCLUSIVO',
      valor: 'EXCLUSIVO'
    }
  ];

  horasServico: string[] = ['00', '01', '02', '03', '04', '05', '06'];
  minutosServico: string[] = ['00', '05', '10', '15', '20', '25', '30',
    '35', '40', '45', '50', '55'];

  valorTotalCustoMaterial: number = 0;
  exibirDialogCusto: boolean = false;
  exibirSpinnerDialog: boolean = false;
  listaItensDisponiveis: ItemProduto[] = [];
  listaItensCustoAdicionados: CustoMaterialServico[] = [];

  exibirDialogValorSugerido: boolean = false;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  valorVenda: number = 0;
  valorLucroDesejado: number = 0;
  valorLucroObtido: number = 0;
  valorSugerido: number = 0;
  novoValorServico: number = 0;
  valorLucroObtidoAtual: number = 0;
  loadingSpinnerDialog: boolean = false;

  constructor(private itemServicoService: ItemServicoService,
    private custoService: CustoService,
    private itemProdutoService: ItemProdutoService,
    private custoMaterialServicoService: CustoMaterialServicoService,
    private subgrupoService: SubgrupoService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.exibirSpinnerPrincipal = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_SERVICO');
    this.carregarIdUrl();
    if (this.permissaoEditar) {
      this.carregarGrupos();
    }
  }
  carregarGrupos() {
    this.subgrupoService.listarSubgruposServicoPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Subgrupo[]) => {
        this.grupos = data.map(item => ({ label: `${item.grupo?.descricao} - ${item.descricao}`, value: item }));
        this.carregarItemServico();
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarItemServico() {
    this.itemServicoService.buscarItemServicoPorId(this.idParametroUrl).subscribe({
      next: (data: ItemServico) => {
        this.itemServico = data;
        this.codigoInicial = data.codigo;
        if (data.subgrupo)
        this.subgrupoSelecionado = data.subgrupo;
        this.carregarListaCusto();
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err)
      }
    })
  }

  carregarListaCusto() {
    this.custoMaterialServicoService.listarPorItemServicoId(this.itemServico?.id).subscribe({
      next: (data: CustoMaterialServico[]) => {
        this.listaItensCustoAdicionados = data;
        this.calcularValorTotalCusto();
        this.exibirSpinnerPrincipal = false;
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err)
      }
    });
  }


  atualizar() {
    if (this.itemServico) {
      this.progressoRequisicao = true;
      this.itemServico.descricao = FormatacaoUtil.removerCaracteresEspeciais(this.itemServico.descricao);
      this.itemServicoService.atualizarItemServico(this.idParametroUrl, this.itemServico).subscribe({
        next: () => {
          this.atualizarCusto();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.exibirMensagemErro(err);
        }
      });
    }
  }

  atualizarCusto() {
    if (this.listaItensCustoAdicionados.length > 0) {
      this.custoMaterialServicoService.salvarListaCusto(this.listaItensCustoAdicionados).subscribe({
        next: (data: CustoMaterialServico[]) => {
          this.listaItensCustoAdicionados = data;
          this.progressoRequisicao = false;
          this.exibirMensagemSucesso();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.exibirMensagemErro(err);
        }
      })
    } else {
      this.progressoRequisicao = false;
      this.exibirMensagemSucesso();
    }
  }

  verificarCodigoExistente(valor: string) {
    if (valor) {
      if (valor !== this.codigoInicial) {
        this.itemServicoService.codigoExistentePorEmpresa(this.getEmpresa().id, valor).subscribe({
          next: (data: any) => {
            this.codigoExistente = data;
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      } else if (valor === this.codigoInicial) {
        this.codigoExistente = false;
      }
    } else {
      this.codigoExistente = false;
    }

  }

  abrirDialogCusto() {
    this.exibirDialogCusto = true;
    this.exibirSpinnerDialog = true;
    this.carregarProdutos();
  }

  carregarProdutos() {
    this.itemProdutoService.listarPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: ItemProduto[]) => {
        this.listaItensDisponiveis = data.filter(produtoDisponivel =>
          !this.listaItensCustoAdicionados.some(itemCusto =>
            itemCusto.itemProduto?.codigo === produtoDisponivel.codigo)
        );
        this.exibirSpinnerDialog = false;
      },
      error: (err: any) => {
        this.exibirSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  adicionarItem(item: ItemProduto) {
    this.listaItensCustoAdicionados.push(
      {
        itemServico: this.itemServico,
        itemProduto: item,
        quantidadeUnidadeMedida: item.quantidadeUnidadeMedida,
        quantidade: 1
      }
    )
    this.calcularPorcentagemCustoMaterial();
    this.exibirDialogCusto = false;
    const posicao = this.listaItensDisponiveis.indexOf(item);
    this.listaItensDisponiveis.splice(posicao, 1);


  }

  calcularValorTotalCusto() {
    for (let item of this.listaItensCustoAdicionados) {
      if (item.itemProduto?.valorCompra && item.quantidadeUnidadeMedida && item.quantidade) {
        this.valorTotalCustoMaterial = this.valorTotalCustoMaterial + (item.itemProduto.valorCompra / item.quantidadeUnidadeMedida) * item.quantidade;
      }
    }
  }

  calcularPorcentagemCustoMaterial() {
    this.valorTotalCustoMaterial = 0;
    this.calcularValorTotalCusto();
    if (this.itemServico?.valorVenda) {
      this.itemServico.custoMaterial = (this.valorTotalCustoMaterial / this.itemServico?.valorVenda) * 100;
    }
  }



  excluirItemCustoAdicionado(item: CustoMaterialServico) {
    if (item.id) {
      this.confirmationService.confirm({
        message: 'Tem certeza que seja excluir?',
        header: 'Item de Custo já salvo',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.custoMaterialServicoService.excluir(item.id).subscribe({
            next: () => {
              this.excluirItemListaCusto(item)
              this.atualizarCustoMaterialItem();
            },
            error: (err: any) => {
              this.exibirMensagemErro(err);
            }
          });
        }
      });

    } else {
      this.excluirItemListaCusto(item);
    }

  }

  excluirItemListaCusto(item: CustoMaterialServico) {
    const posicao = this.listaItensCustoAdicionados.indexOf(item);
    this.listaItensCustoAdicionados.splice(posicao, 1);

    this.calcularPorcentagemCustoMaterial();
  }

  atualizarCustoMaterialItem() {
    const custoAtualizado: ItemServicoCustoMaterial = {
      itemServicoId: this.itemServico?.id,
      custoMaterial: this.itemServico?.custoMaterial
    }
    this.itemServicoService.atualizarCustoMaterial(custoAtualizado).subscribe({
      next: () => {
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }


  abrirDialogValorSugerido() {
    this.loadingSpinnerDialog = true;
    this.novoValorServico = 0;
    this.valorLucroDesejado = 0;
    this.valorLucroObtido = 0;
    this.valorSugerido = 0;
    this.exibirDialogValorSugerido = true;
    this.obterCustos();
  }

  obterCustos() {
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.calcularLucroObtidoAtual();
        this.loadingSpinnerDialog = false;
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirDialogValorSugerido = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  calcularLucroDesejado(event: any) {
    this.valorLucroDesejado = event.value ?? 0;
    if (this.valorLucroDesejado > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const sugestao = ((this.valorLucroDesejado * somaPercentuais) / ((somaPercentuais - 100) * -1)) + this.valorLucroDesejado;
      this.valorSugerido = sugestao;
    } else {
      this.valorSugerido = 0;
    }
  }

  calcularLucroObtido(valor?: number) {
    this.novoValorServico = valor ?? 0;
    if (this.novoValorServico > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const valorCustosTotais = (somaPercentuais / 100) * this.novoValorServico;
      if (this.novoValorServico) {
        this.valorLucroObtido = Number((this.novoValorServico - valorCustosTotais).toFixed(2));
      }
    } else {
      this.valorLucroObtido = 0;
    }

  }

  calcularLucroObtidoAtual() {
    if (this.itemServico 
      && this.itemServico.valorVenda 
      && this.itemServico.valorVenda > 0) {
      const somaPercentuais = this.custoMedio.custoFixo 
        + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0)
        + this.custoMedio.imposto;
        
      const valorCustosTotais = (somaPercentuais / 100) * this.itemServico.valorVenda;
      this.valorLucroObtidoAtual = Number((this.itemServico.valorVenda - valorCustosTotais).toFixed(2));
    } else {
      this.valorLucroObtidoAtual = 0;
    }
  }

  confirmarValorServico() {
    if (this.itemServico) {
      this.itemServico.valorVenda = this.novoValorServico;
    }
    this.exibirDialogValorSugerido = false;
  }

}
